import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SpecialityResponse } from "../../models/dtos";

export const specialitiesApi = createApi({
  reducerPath: "specialitiesApi",
  baseQuery: baseAuthQuery("Specialities"),
  tagTypes: ["Speciality"],
  endpoints: (builder) => ({
    getSpecialities: builder.query<ApiResponse<SpecialityResponse[]>, void>({
      query: () => "",
      providesTags: ["Speciality"],
    }),
    getSpecialitiesAsFlatList: builder.query<ApiResponse<SpecialityResponse[]>, void>({
      query: () => ({ url: "", method: "GET", params: { flatList: true } }),
      providesTags: ["Speciality"],
    }),
    getSpecialityById: builder.query<ApiResponse<SpecialityResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["Speciality"],
    }),
    updateSpeciality: builder.mutation<ApiResponse<SpecialityResponse>, Partial<SpecialityResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["Speciality"],
    }),
    deleteSpeciality: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["Speciality"],
    }),
    getSpecialityChildren: builder.query<ApiResponse<SpecialityResponse[]>, number>({
      query: (id) => ({ url: `${id}/children` }),
      providesTags: ["Speciality"],
    }),
  }),
});
